<template>
  <div id="stream">
    <p id="streamtitle">
      Livestream
    </p>
    <div id="streamcontent">
        <video v-if="active" ref="video"
            controls
            autoplay
            :poster="poster(stream.playbackId)"
          >
        </video>
        <div class="notification" v-if="!active"><span> There is currently no livestream, please come back later.</span></div>
        <!-- <div class="notification" v-if="!active"> Unmute livestream</div> -->
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js'
import interactions from "../interactions";

export default {
  name: 'ExternalStream',
  components: {
  },
  props: [
    'stream'
  ],
  data() {
    return {
      x: null,
      y: null,
      lockedRatio: true
    }
  },
  computed: {
    active() { return this.stream.status === 'active' }
  },
  watch: {
    stream(newState) {
      // if (oldState !== newState && newState.playbackId) {
      if (newState.status === 'active') {
        setTimeout(() => {
          this.updateVideo()
        }, 300)
      }
    }
  },
  mounted() {
    this.updateVideo();
    let VueThis = this;
    interactions.dragDrop(
      "#stream",
      "#streamtitle",
      "#streamcontent",
      VueThis.x,
      VueThis.y,
      this.lockedRatio
    );
  },
  methods: {

    src: playbackId => `https://stream.mux.com/${playbackId}.m3u8`,
    poster: playbackId => `https://image.mux.com/${playbackId}/thumbnail.jpg`,


    updateVideo() {
      // console.log('updating video')

      const playbackId = this.stream.playbackId

      const sourceUrl = this.src(playbackId)
      const video = this.$refs.video

      // If HLS.js is supported on this platform

      if (Hls.isSupported()) {
        const hls = new Hls()
        hls.loadSource(sourceUrl)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.controls = true
          video.play()
        })


      // If the player can support HLS natively

      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = sourceUrl
        video.addEventListener('loadedmetadata', () => {
          video.controls = true
          video.play()
        })
      }

    }
  }
}
</script>

<style scoped>

#stream >>> video {
  width:100%;
  height:auto;
  object-fit: contain;
  background: black;
}

#stream {
  position: absolute;
  left:5vw;
  background-color: #6d6d6d;
  border: 3px solid transparent;
  /* z-index: 1000; */
  width:initial !important;
  margin-top:0px;
  filter: drop-shadow(0 0 0.3rem rgba(0, 0, 0, 0.733));
}

#stream p {
  border-bottom: 1px solid black;
  top: 0;
  font-size: 16px;
  margin-block-start: 0;
  padding: 5px;
  background-color: #6d6d6d;
}

.notification {
  padding:10px;
  margin:12px;
  background-color: #c7ffd0;
  border: 1px solid black;
}

#stream #streamtitle {
  position: sticky;
  margin: 0;
  top: 0;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

#streamcontent {
  width:55vw;
  overflow-y: hidden;
  min-height:45vh;
  min-width:80px;
}
</style>